import { BehaviorSubject } from 'rxjs';
import { IValidationService } from '../interfaces/validation-service.interface';
import { CheckerComments, ValidationResult, ValidationLevel } from '../types/validation-types';

/**
 * No-Op ValidationService für Apps ohne Validierungs-Feature.
 * Alle validate-Aufrufe geben OK zurück, keine Kommentare.
 */
export class NullValidationService implements IValidationService {
	dirty = new BehaviorSubject<boolean>(false);
	commentsChanged = new BehaviorSubject<string | null>(null);

	validate(_key: string, _data: unknown): ValidationResult {
		return ValidationResult.ok();
	}

	hasComments(_key: string): CheckerComments | false { return false; }
	clearKey(_key: string): void { }
	registerDanger(_key: string, _msg: string): void { }
	registerWarning(_key: string, _msg: string): void { }
	registerMessage(_key: string, _msg: string): void { }
	registerDangerComment(_key: string, _msg: string): void { }
	registerWarningComment(_key: string, _msg: string): void { }
	registerMessageComment(_key: string, _msg: string): void { }
	clearComments(_key: string): void { }
	clearCommentsNoSave(_key: string): void { }
	resetComments(_key: string, _comments: CheckerComments): void { }
	getMaxCommentSeverityByPrefix(_prefix: string): number { return ValidationLevel.ok; }
}
